<a [href]="link" (click)="handleClick($event)" [class]="styleClass"> <i [class]="iconsClass"></i> {{ title }}</a>